import { render } from "./WordFrequency.vue?vue&type=template&id=59d0d9a6&scoped=true"
import script from "./WordFrequency.vue?vue&type=script&lang=js"
export * from "./WordFrequency.vue?vue&type=script&lang=js"

import "./WordFrequency.vue?vue&type=style&index=0&id=59d0d9a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d0d9a6"]])

export default __exports__